(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
      })();
      (function() {
  if (!__sections__["featured-product"] && !window.DesignMode) return;
  try {
    
  if (!customElements.get('product-modal')) {
    customElements.define('product-modal', class ProductModal extends ModalDialog {
      constructor() {
        super();
      }

      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
      }

      showActiveMedia() {
        this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
            element.classList.remove('active');
          }
        )
        const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');
        activeMedia.scrollIntoView();

        const container = this.querySelector('[role="document"]');
        container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

        if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMediaContent && activeMediaContent.querySelector('.js-youtube'))
          activeMedia.loadContent();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
	const locationMobileTrigger = document.querySelector('.js-toggle-locations');
	const locationDrawerSummary = document.querySelector('#location-drawer summary');
	const mobileLocationsLink = document.querySelector('.js-mobile-locations');
	const menuSummary = document.querySelector('#main-menu-drawer summary');

	locationMobileTrigger.addEventListener('click', (ev) => {
		ev.preventDefault();
		const locationMq = window.matchMedia('(min-width: 560px)');

		if (locationMq.matches) {
			menuSummary.click();
			locationDrawerSummary.click();
		} else {
			mobileLocationsLink.click();
		}
	});

  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.getElementById('shopify-section-header');
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');
			this.animationOnPage = document.querySelector('.ring-animation__canvas') ? document.querySelector('.ring-animation__canvas') : false;
			this.animationIsInViewport = false;

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();

			if (this.animationOnPage) {
				this.createAnimationObserver();
			}
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

		createAnimationObserver() {
			let observer = new IntersectionObserver((entries, observer) => {
				if (entries[0].intersectionRatio > 0) {
					this.animationIsInViewport = true;
				} else {
					this.animationIsInViewport = false;
				}
			}, {
				root: null,
				rootMargin: '0px',
				threshold: 0
			});

			observer.observe(this.animationOnPage);
		}

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
				if (
					this.animationOnPage &&
					this.animationIsInViewport
				) {
					window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        } else if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        requestAnimationFrame(this.reset.bind(this));
      }


      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }
  customElements.define('sticky-header', StickyHeader);

  class HeaderDropdown extends HTMLElement {
    constructor() {
      super();
      this.mainDetailsToggle = this.querySelector('details');
      this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

      this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
      this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));

      this.siteHeader = document.querySelector('.js-site-header');
      this.megaMenuOpenClass = 'header--mega-menu-is-open';

      window.addEventListener('DOMContentLoaded', this.onLoad.bind(this));
    }

    onFocusOut(ev) {
			setTimeout(() => {
				console.log('newly focused element:', ev.relatedTarget);
				if (!this.contains(document.activeElement)) this.close();
			});
    }

    onToggle() {
      if (!this.animations) this.animations = this.content.getAnimations();

      if (this.mainDetailsToggle.hasAttribute('open')) {
        this.animations.forEach(animation => animation.play());
        if (this.mainDetailsToggle.classList.contains('has-mega-menu')) {
          this.siteHeader.classList.add(this.megaMenuOpenClass);
        }
      } else {
        this.animations.forEach(animation => animation.cancel());
        this.siteHeader.classList.remove(this.megaMenuOpenClass);
      }
    }

    onLoad() {
      if (this.mainDetailsToggle.hasAttribute('open') && this.mainDetailsToggle.classList.contains('has-mega-menu')) {
        this.siteHeader.classList.add(this.megaMenuOpenClass);
      }
    }

    close() {
      this.mainDetailsToggle.removeAttribute('open');
      this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
      this.siteHeader.classList.remove(this.megaMenuOpenClass);
    }
  }

  customElements.define('header-dropdown', HeaderDropdown);


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-footer"]) return;
  try {
    
  class CartNote extends HTMLElement {
    constructor() {
      super();

      this.addEventListener('change', debounce((event) => {
        const body = JSON.stringify({ note: event.target.value });
        fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }});
      }, 300))
    }
  }

  customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
	const clickAndCollectTrigger = document.querySelector('.js-click-and-collect-open');

	clickAndCollectTrigger.addEventListener('click', (ev) => {
		ev.preventDefault();
		const openClickAndCollectonButton = document.querySelector('#cnc-container .btn');
		openClickAndCollectonButton.click();
	});

  class ProductModal extends ModalDialog {
    constructor() {
      super();
    }

    hide() {
      super.hide();
    }

    show(opener) {
      super.show(opener);
      this.showActiveMedia();
    }

    showActiveMedia() {
      this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
          element.classList.remove('active');
        }
      )
      const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
      const activeMediaTemplate = activeMedia.querySelector('template');
      const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
      activeMedia.classList.add('active');
      activeMedia.scrollIntoView();

      const container = this.querySelector('[role="document"]');
      container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

      if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMediaContent && activeMediaContent.querySelector('.js-youtube'))
        activeMedia.loadContent();
    }
  }

  if (!customElements.get('product-modal')) customElements.define('product-modal', ProductModal);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["notice-bar"]) return;
  try {
    
class NoticeBar extends HTMLElement {
	constructor() {
		super();
		this.bindEvents();
		this.cookieKey = 'noticeBarHidden';
		this.cookieMaxAge = 60 * 60 * 24; /* 1 day */

		if (!this.getCookieValue()) {
			this.showNoticeBar();
		}
	}

	bindEvents() {
		this.querySelectorAll('.js-notice-bar-button-close').forEach(button => button.addEventListener('click', this.onCloseButtonClick.bind(this)));
	}

	onCloseButtonClick() {
		this.hideNoticeBar();
	}

	hideNoticeBar() {
		this.noticeBar = this;
		this.noticeBar.classList.add('notice-bar--hidden');
		this.setCookie();
	}

	showNoticeBar() {
		this.noticeBar = this;
		this.noticeBar.classList.remove('notice-bar--hidden');
	}

	setCookie() {
		document.cookie = `${this.cookieKey}=true; max-age=${this.cookieMaxAge}`;
	}

	getCookieValue() {
		if (document.cookie.indexOf(this.cookieKey) !== -1) {
			return document.cookie.split('; ').find(row => row.startsWith(this.cookieKey)).split('=')[1];
		}

		return false;
	}
}
customElements.define('notice-bar', NoticeBar);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"] && !window.DesignMode) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');

            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }

            if (html.querySelector('.slider__slide')) {
              this.classList.add('product-recommendations--loaded');
            }
          })
          .catch(e => {
            console.error(e);
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ring-animation"]) return;
  try {
    
	// https://davidwalsh.name/javascript-debounce-function
	// Returns a function, that, as long as it continues to be invoked, will not
	// be triggered. The function will be called after it stops being called for
	// N milliseconds. If `immediate` is passed, trigger the function on the
	// leading edge, instead of the trailing.
	function debounce(func, wait, immediate) {
		var timeout;

		return function() {
			var context = this, args = arguments;
			var later = function() {
				timeout = null;
				if (!immediate) func.apply(context, args);
			};

			var callNow = immediate && !timeout;

			clearTimeout(timeout);

			timeout = setTimeout(later, wait);

			if (callNow) func.apply(context, args);
		};
	}

	// Shamelessly ripped this off: https://codepen.io/osublake/pen/VwaKMpw/2152a28cffe2c2c0cca8a3e47f7b21c6?editors=1111
	class RingAnimation extends HTMLElement {
		constructor() {
			super();

			this.container = this.querySelector('.ring-animation__container');
			this.canvas = this.querySelector('canvas');
			this.context = this.canvas.getContext('2d');
			this.frameCount = 468;
			this.images = [];
			this.video = this.querySelector('video');
			this.mq = {};

			this.ring = {
				frame: 0
			};

			this.text = {
				create: this.querySelector('.ring-animation__text--create'),
				unique: this.querySelector('.ring-animation__text--unique'),
				you: this.querySelector('.ring-animation__text--you'),
				start: this.querySelector('.ring-animation__start')
			};

			this.init();
		}

		init() {
			this.mq = window.matchMedia('(min-width: 990px)');

			// this.canvas.width = 1920;
			// this.canvas.height = 1080;

			this.canvas.width = window.innerWidth;
			this.canvas.height = window.innerHeight;

			if (this.mq.matches) {
				this.populateImages();
				this.images[this.ring.frame].onload = this.renderFrame(this.canvas, this.context, this.images, this.ring);
			} else {
				this.video.src = this.video.dataset.src;
				this.video.removeAttribute('data-src');
			}

			// Delay binding until after deferred scripts are loaded.
			document.addEventListener('DOMContentLoaded', () => {
				this.bindEvents();
			});
		}

		populateImages() {
			for (let i = 0; i < this.frameCount; i++) {
				const img = new Image();
				img.src = this.getCurrentFrame(i);
				this.images.push(img);
			}
		}

		getCurrentFrame(index) {
      const filename = `ring-animation-image-${(index + 1).toString().padStart(3, '0')}.webp`;
			const pathComponents = this.dataset.firstFrame.split('ring-animation-image-000.webp');
      const path = pathComponents[0];
			return `${path}${filename}`;
		}

		bindEvents() {
			window.addEventListener('resize', debounce(() => {
				this.resizeWatcher();
			}, 250));

			gsap.registerPlugin(ScrollTrigger);

			ScrollTrigger.matchMedia({
				// DESKTOP ANIMATION
				"(min-width: 990px)": () => {
					this.text.start.style = "";

					const timeline = new TimelineMax({
						scrollTrigger: {
							scrub: 0.5,
							trigger: this.canvas,
							start: "top 30%",
							end: "+=400%",
						},
					});

					timeline.add("start", 0);

					timeline.to(this.ring, {
						frame: this.frameCount - 1,
						snap: "frame",
						ease: "none",
						onUpdate: () => {
							this.renderFrame(this.canvas, this.context, this.images, this.ring);
						}
					}, "start");

					timeline.to(this.text.create, {
						opacity: 1,
						duration: 0.05,
					}, "0.2");

					timeline.to(this.text.create, {
						opacity: 0,
						duration: 0.05,
					}, ">+0.05");

					timeline.to(this.text.unique, {
						opacity: 1,
						duration: 0.05,
					}, ">+0.01");

					timeline.to(this.text.unique, {
						opacity: 0,
						duration: 0.05,
					}, ">+0.015");

					timeline.to(this.text.you, {
						opacity: 1,
						duration: 0.025,
					}, ">-0.05");

					timeline.to(this.text.you, {
						opacity: 0,
						duration: 0.05,
					}, ">+0.05");

					timeline.to(this.text.start, {
						opacity: 1,
						duration: 0.025,
					}, ">-0.01");

					ScrollTrigger.create({
						trigger: this.canvas,
						start: "top top",
						end: "+=370%",
						pin: document.querySelector('.ring-animation__container'),
					})
				},

				// MOBILE/TABLET ANIMATION
				"(max-width: 989px)": () => {
					this.text.start.style = "";

					const mobileTimeline = new TimelineMax({
						scrollTrigger: {
							trigger: document.querySelector('.ring-animation__mobile-container'),
							start: "top 90%",
							toggleActions: "play none none none",
							onEnter: () => this.video.play()
						},
					});

					mobileTimeline.add("start", 0);

					mobileTimeline.to(this.text.create, {
						opacity: 1,
						duration: 1,
					}, 0);

					// mobileTimeline.to(this.text.create, {
					// 	opacity: 0,
					// 	duration: 1,
					// }, ">+2");

					mobileTimeline.to(this.text.unique, {
						opacity: 1,
						duration: 1,
					}, ">+1");

					// mobileTimeline.to(this.text.unique, {
					// 	opacity: 0,
					// 	duration: 1,
					// }, ">+2");

					mobileTimeline.to(this.text.you, {
						opacity: 1,
						duration: 1,
					}, ">+1");

					// mobileTimeline.to(this.text.you, {
					// 	opacity: 0,
					// 	duration: 1,
					// }, ">+2");

					// mobileTimeline.to(this.video, {
					// 	xPercent: 25,
					// 	duration: 2,
					// }, "start+=17");
				}
			});
		}

		/**
		 * Emulate "cover" or "contain" CSS functionality
		 *
		 * @param context
		 * @param image
		 * @param type
		 *
		 * @url https://stackoverflow.com/a/60066003
		 */
		renderImage(context, image, type) {
			const imageRatio = image.height / image.width;
			const windowRatio = window.innerHeight / window.innerWidth;

			if ((imageRatio < windowRatio && type === 'contain') || (imageRatio > windowRatio && type === 'cover')) {
				const height = window.innerWidth * imageRatio;
				context.drawImage(image, 0, (window.innerHeight - height) / 2, window.innerWidth, height);
			}

			if ((imageRatio > windowRatio && type === 'contain') || (imageRatio < windowRatio && type === 'cover')) {
				const width = window.innerWidth * windowRatio / imageRatio;
				context.drawImage(image, (window.innerWidth - width) / 2, 0, width, window.innerHeight);
			}
		}

		renderFrame(canvas, context, images, ring) {
			context.clearRect(0, 0, canvas.width, canvas.height);
			// context.drawImage(images[ring.frame], 0, 0, canvas.width, canvas.height);
			this.renderImage(context, images[ring.frame], 'cover');
		}

		resizeWatcher() {
			if (!this.mq.matches && !this.video.hasAttribute('src')) {
				this.video.src = this.video.dataset.src;
				this.video.removeAttribute('data-src');
			} else if (this.mq.matches && this.images.length === 0) {
				this.populateImages();
				this.images[this.ring.frame].onload = () => {this.renderFrame(this.canvas, this.context, this.images, this.ring)};
			}

			if (this.mq.matches) {
				this.canvas.width = window.innerWidth;
				this.canvas.height = window.innerHeight;

				this.renderFrame(this.canvas, this.context, this.images, this.ring);
			}
		}
	}

	customElements.define('ring-animation', RingAnimation);

  } catch(e) { console.error(e); }
})();
      })();
